<div class="container mt-5" *ngIf="airaOutput && airaOutput.retrieval_model">
    @if (airaOutput.previous_company_number){
    <a [attr.href]="'/aira?airaRunId='+airaRunId+'&companyNumber='+airaOutput.previous_company_number"
        class="arrow-link left-arrow">
        <i class="fal fa-arrow-alt-circle-left cursor-pointer"></i>
    </a>
    }
    <div class="left-side">
        <mat-card>
            <mat-card-header>
                <mat-card-title>General Information</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-list>
                    <mat-list-item>
                        <span class="label">{{ airaOutput.metadata?.engine_version === 'v3' ? 'Planner Model:' : 'Retrieval Model:' }}</span>
                        <span class="value">
                            <img class="logo" src="https://www.google.com/s2/favicons?domain=google.com"
                                alt="Google Logo" *ngIf="airaOutput.retrieval_model.startsWith('gemini')">
                            <img class="logo" src="https://www.google.com/s2/favicons?domain=openai.com"
                                alt="OpenAI Logo" *ngIf="!airaOutput.retrieval_model.startsWith('gemini')">
                            {{ airaOutput.retrieval_model }}
                        </span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">{{ airaOutput.metadata?.engine_version === 'v3' ? 'Answering Model:' : 'Reasoning Model:' }}</span>
                        <span class="value">
                            <img class="logo" src="https://www.google.com/s2/favicons?domain=google.com"
                                alt="Google Logo" *ngIf="airaOutput.reasoning_model.startsWith('gemini')">
                            <img class="logo" src="https://www.google.com/s2/favicons?domain=openai.com"
                                alt="OpenAI Logo" *ngIf="!airaOutput.reasoning_model.startsWith('gemini')">
                            {{ airaOutput.reasoning_model }}
                        </span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Retrieval Input Tokens:</span>
                        <span class="value">{{ airaOutput.retrieval_input_tokens }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Retrieval Output Tokens:</span>
                        <span class="value">{{ airaOutput.retrieval_output_tokens }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Retrieval Cached Tokens:</span>
                        <span class="value">{{ airaOutput.retrieval_cached_tokens }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Engine Version:</span>
                        <span class="value">{{ airaOutput.metadata?.engine_version }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Reasoning Input Tokens:</span>
                        <span class="value">{{ airaOutput.reasoning_input_tokens }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Reasoning Output Tokens:</span>
                        <span class="value">{{ airaOutput.reasoning_output_tokens }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">UK Companies Count:</span>
                        <span class="value">{{ airaOutput.uk_companies_count }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Questions Answered:</span>
                        <span class="value">{{ airaOutput.questions_answered }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Answers Failed:</span>
                        <span class="value">{{ airaOutput.metadata?.answers_failed }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Latest Update:</span>
                        <span class="value">{{ airaOutput.latest_update }}</span>
                    </mat-list-item>
                </mat-list>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="right-side">
        <mat-card>
            <mat-card-header>
                <mat-card-title>Financial Information</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-list>
                    <mat-list-item class="financial-data">
                        <span class="label">Total Retrieval Cost:</span>
                        <span class="value">{{ (airaOutput.total_retrieval_cost).toPrecision(3) }} USD</span>
                    </mat-list-item>
                    <mat-list-item class="financial-data">
                        <span class="label">Total Reasoning Cost:</span>
                        <span class="value">{{ (airaOutput.total_reasoning_cost).toPrecision(3) }} USD</span>
                    </mat-list-item>
                    <mat-list-item class="financial-data">
                        <span class="label">Avg. Retrieval Cost/Company:</span>
                        <span class="value">{{ (airaOutput.average_retrieval_cost_per_company).toPrecision(3) }}
                            USD</span>
                    </mat-list-item>
                    <mat-list-item class="financial-data">
                        <span class="label">Avg. Retrieval Cost/Company/Q:</span>
                        <span class="value">{{ (airaOutput.average_retrieval_cost_per_company_question).toPrecision(3)
                            }} USD</span>
                    </mat-list-item>
                    <mat-list-item class="financial-data">
                        <span class="label">Avg. Reasoning Cost/Company:</span>
                        <span class="value">{{ (airaOutput.average_reasoning_cost_per_company).toPrecision(3) }}
                            USD</span>
                    </mat-list-item>
                    <mat-list-item class="financial-data">
                        <span class="label">Avg. Reasoning Cost/Company/Q:</span>
                        <span class="value">{{ (airaOutput.average_reasoning_cost_per_company_question).toPrecision(3)
                            }} USD</span>
                    </mat-list-item>
                    <mat-list-item class="financial-data">
                        <span class="label">Avg. Total Cost/Company/Q:</span>
                        <span class="value">{{ (airaOutput.average_total_cost_per_company_question).toPrecision(3) }}
                            USD</span>
                    </mat-list-item>
                    <mat-list-item class="financial-data">
                        <span class="label">Avg. Total Cost/Company:</span>
                        <span class="value">{{ (airaOutput.average_total_cost_per_company).toPrecision(3) }} USD</span>
                    </mat-list-item>
                </mat-list>
            </mat-card-content>
        </mat-card>
    </div>
    @if (airaOutput.next_company_number){
    <a [attr.href]="'/aira?airaRunId='+airaRunId+'&companyNumber='+airaOutput.next_company_number"
        class="arrow-link right-arrow">
        <i class="fal fa-arrow-alt-circle-right cursor-pointer"></i>
    </a>
    }
</div>

<!-- V3 Progress Section -->
<div class="container mt-5" *ngIf="airaOutput?.v3_progress && airaOutput.metadata?.engine_version === 'v3'">
    <div class="left-side">
        <mat-card>
            <mat-card-header>
                <mat-card-title>V3 Progress</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-list>
                    <mat-list-item>
                        <span class="label">State:</span>
                        <span class="value">{{ airaOutput.v3_progress.state }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Expected Answer Units:</span>
                        <span class="value">{{ airaOutput.v3_progress.expected_answer_units }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Answers Succeeded:</span>
                        <span class="value">{{ airaOutput.v3_progress.answers_succeeded }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Answers Retrying:</span>
                        <span class="value">{{ airaOutput.v3_progress.answers_retrying }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Answers Failed:</span>
                        <span class="value">{{ airaOutput.v3_progress.answers_failed }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Answers Outstanding:</span>
                        <span class="value">{{ airaOutput.v3_progress.answers_outstanding }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Active Batches:</span>
                        <span class="value">{{ airaOutput.v3_progress.active_batches }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Last Progress At:</span>
                        <span class="value">{{ airaOutput.v3_progress.last_progress_at }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Stalled At:</span>
                        <span class="value">{{ airaOutput.v3_progress.stalled_at }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Finalisation Reason:</span>
                        <span class="value">{{ airaOutput.v3_progress.finalisation_reason }}</span>
                    </mat-list-item>
                    <mat-list-item *ngFor="let status of objectKeys(airaOutput.v3_progress.work_items_by_status)">
                        <span class="label">Work Items {{ status }}:</span>
                        <span class="value">{{ airaOutput.v3_progress.work_items_by_status[status] }}</span>
                    </mat-list-item>
                </mat-list>
            </mat-card-content>
        </mat-card>
    </div>
</div>

<!-- V3 One-Sweep Batches Section -->
<div class="container mt-5" *ngIf="airaOutput?.batch_details?.v3_one_sweep">
    <div class="left-side">
        <mat-card>
            <mat-card-header>
                <mat-card-title>V3 One-Sweep Batches</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-list>
                    <mat-list-item>
                        <span class="label">Total:</span>
                        <span class="value">{{ airaOutput.batch_details.v3_one_sweep.total }}</span>
                    </mat-list-item>
                    <mat-list-item *ngFor="let status of objectKeys(airaOutput.batch_details.v3_one_sweep.by_status)">
                        <span class="label">{{ status }}:</span>
                        <span class="value">{{ airaOutput.batch_details.v3_one_sweep.by_status[status] }}</span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.batch_details.v3_one_sweep.oldest_batch">
                        <span class="label">Oldest Batch:</span>
                        <span class="value">{{ airaOutput.batch_details.v3_one_sweep.oldest_batch | json }}</span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.batch_details.v3_one_sweep.newest_batch">
                        <span class="label">Newest Batch:</span>
                        <span class="value">{{ airaOutput.batch_details.v3_one_sweep.newest_batch | json }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Processed Batches:</span>
                        <span class="value">{{ airaOutput.batch_details.v3_one_sweep.processed_batches }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Unprocessed Terminal Batches:</span>
                        <span class="value">{{ airaOutput.batch_details.v3_one_sweep.unprocessed_terminal_batches }}</span>
                    </mat-list-item>
                    <mat-list-item *ngFor="let batch of airaOutput.batch_details.v3_one_sweep.batches">
                        <span class="label">Batch:</span>
                        <span class="value">{{ batch | json }}</span>
                    </mat-list-item>
                </mat-list>
            </mat-card-content>
        </mat-card>
    </div>
</div>

<!-- Batch Details Section -->
<div class="container mt-5" *ngIf="airaOutput && airaOutput.batch_details && airaOutput.metadata?.engine_version !== 'v3'">
    <div class="left-side">
        <mat-card>
            <mat-card-header>
                <mat-card-title>Retrieval Batches Summary</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-list *ngIf="airaOutput.batch_details.retrieval_batches.total > 0">
                    <mat-list-item>
                        <span class="label">Total Batches:</span>
                        <span class="value">{{ airaOutput.batch_details.retrieval_batches.total }}</span>
                    </mat-list-item>
                    <mat-list-item *ngFor="let status of objectKeys(airaOutput.batch_details.retrieval_batches.by_status)">
                        <span class="label">{{ status }}:</span>
                        <span class="value">{{ airaOutput.batch_details.retrieval_batches.by_status[status] }}</span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.batch_details.retrieval_batches.has_failures" class="warning">
                        <span class="label">⚠️ Has Failures:</span>
                        <span class="value">Yes</span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.batch_details.retrieval_batches.has_pending">
                        <span class="label">🔄 Has Pending:</span>
                        <span class="value">Yes</span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.batch_details.retrieval_batches.oldest_batch">
                        <span class="label">Oldest Batch:</span>
                        <span class="value">ID {{ airaOutput.batch_details.retrieval_batches.oldest_batch.id }} ({{ airaOutput.batch_details.retrieval_batches.oldest_batch.status }})</span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.batch_details.retrieval_batches.newest_batch">
                        <span class="label">Newest Batch:</span>
                        <span class="value">ID {{ airaOutput.batch_details.retrieval_batches.newest_batch.id }} ({{ airaOutput.batch_details.retrieval_batches.newest_batch.status }})</span>
                    </mat-list-item>
                </mat-list>
                <p *ngIf="airaOutput.batch_details.retrieval_batches.total === 0">No retrieval batches</p>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="right-side">
        <mat-card>
            <mat-card-header>
                <mat-card-title>Reasoning Batches Summary</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-list *ngIf="airaOutput.batch_details.reasoning_batches.total > 0">
                    <mat-list-item>
                        <span class="label">Total Batches:</span>
                        <span class="value">{{ airaOutput.batch_details.reasoning_batches.total }}</span>
                    </mat-list-item>
                    <mat-list-item *ngFor="let status of objectKeys(airaOutput.batch_details.reasoning_batches.by_status)">
                        <span class="label">{{ status }}:</span>
                        <span class="value">{{ airaOutput.batch_details.reasoning_batches.by_status[status] }}</span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.batch_details.reasoning_batches.has_failures" class="warning">
                        <span class="label">⚠️ Has Failures:</span>
                        <span class="value">Yes</span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.batch_details.reasoning_batches.has_pending">
                        <span class="label">🔄 Has Pending:</span>
                        <span class="value">Yes</span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.batch_details.reasoning_batches.oldest_batch">
                        <span class="label">Oldest Batch:</span>
                        <span class="value">ID {{ airaOutput.batch_details.reasoning_batches.oldest_batch.id }} ({{ airaOutput.batch_details.reasoning_batches.oldest_batch.status }})</span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.batch_details.reasoning_batches.newest_batch">
                        <span class="label">Newest Batch:</span>
                        <span class="value">ID {{ airaOutput.batch_details.reasoning_batches.newest_batch.id }} ({{ airaOutput.batch_details.reasoning_batches.newest_batch.status }})</span>
                    </mat-list-item>
                </mat-list>
                <p *ngIf="airaOutput.batch_details.reasoning_batches.total === 0">No reasoning batches</p>
            </mat-card-content>
        </mat-card>
    </div>
</div>

<!-- Queue Details Section -->
<div class="container mt-5" *ngIf="airaOutput && airaOutput.queue_details">
    <div class="left-side">
        <mat-card>
            <mat-card-header>
                <mat-card-title>Retrieval Queue ({{ airaOutput.queue_details.retrieval_queue.count }} messages)
                    <span *ngIf="airaOutput.queue_details._cached" class="cached-badge">(cached)</span>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-list *ngIf="airaOutput.queue_details.retrieval_queue.count > 0">
                    <mat-list-item>
                        <span class="label">Total Messages:</span>
                        <span class="value">{{ airaOutput.queue_details.retrieval_queue.count }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Unique Companies:</span>
                        <span class="value">{{ airaOutput.queue_details.retrieval_queue.unique_companies }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Unique Questions:</span>
                        <span class="value">{{ airaOutput.queue_details.retrieval_queue.unique_questions }}</span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.queue_details.retrieval_queue.retry_attempts">
                        <span class="label">Retry Attempts (min/avg/max):</span>
                        <span class="value">
                            {{ airaOutput.queue_details.retrieval_queue.retry_attempts.min }} / 
                            {{ airaOutput.queue_details.retrieval_queue.retry_attempts.avg.toFixed(1) }} / 
                            {{ airaOutput.queue_details.retrieval_queue.retry_attempts.max }}
                        </span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.queue_details.retrieval_queue.approximate_receive_counts">
                        <span class="label">Receive Counts (min/avg/max):</span>
                        <span class="value">
                            {{ airaOutput.queue_details.retrieval_queue.approximate_receive_counts.min }} / 
                            {{ airaOutput.queue_details.retrieval_queue.approximate_receive_counts.avg.toFixed(1) }} / 
                            {{ airaOutput.queue_details.retrieval_queue.approximate_receive_counts.max }}
                        </span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.queue_details.retrieval_queue.age">
                        <span class="label">Age (min/avg/max):</span>
                        <span class="value">
                            {{ airaOutput.queue_details.retrieval_queue.age.min }} / 
                            {{ airaOutput.queue_details.retrieval_queue.age.avg }} / 
                            {{ airaOutput.queue_details.retrieval_queue.age.max }}
                        </span>
                    </mat-list-item>
                </mat-list>
                <p *ngIf="airaOutput.queue_details.retrieval_queue.count === 0">No messages in retrieval queue</p>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="right-side">
        <mat-card>
            <mat-card-header>
                <mat-card-title>Reasoning Queue ({{ airaOutput.queue_details.reasoning_queue.count }} messages)
                    <span *ngIf="airaOutput.queue_details._cached" class="cached-badge">(cached)</span>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-list *ngIf="airaOutput.queue_details.reasoning_queue.count > 0">
                    <mat-list-item>
                        <span class="label">Total Messages:</span>
                        <span class="value">{{ airaOutput.queue_details.reasoning_queue.count }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Unique Companies:</span>
                        <span class="value">{{ airaOutput.queue_details.reasoning_queue.unique_companies }}</span>
                    </mat-list-item>
                    <mat-list-item>
                        <span class="label">Unique Questions:</span>
                        <span class="value">{{ airaOutput.queue_details.reasoning_queue.unique_questions }}</span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.queue_details.reasoning_queue.retry_attempts">
                        <span class="label">Retry Attempts (min/avg/max):</span>
                        <span class="value">
                            {{ airaOutput.queue_details.reasoning_queue.retry_attempts.min }} / 
                            {{ airaOutput.queue_details.reasoning_queue.retry_attempts.avg.toFixed(1) }} / 
                            {{ airaOutput.queue_details.reasoning_queue.retry_attempts.max }}
                        </span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.queue_details.reasoning_queue.approximate_receive_counts">
                        <span class="label">Receive Counts (min/avg/max):</span>
                        <span class="value">
                            {{ airaOutput.queue_details.reasoning_queue.approximate_receive_counts.min }} / 
                            {{ airaOutput.queue_details.reasoning_queue.approximate_receive_counts.avg.toFixed(1) }} / 
                            {{ airaOutput.queue_details.reasoning_queue.approximate_receive_counts.max }}
                        </span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.queue_details.reasoning_queue.age">
                        <span class="label">Age (min/avg/max):</span>
                        <span class="value">
                            {{ airaOutput.queue_details.reasoning_queue.age.min }} / 
                            {{ airaOutput.queue_details.reasoning_queue.age.avg }} / 
                            {{ airaOutput.queue_details.reasoning_queue.age.max }}
                        </span>
                    </mat-list-item>
                </mat-list>
                <p *ngIf="airaOutput.queue_details.reasoning_queue.count === 0">No messages in reasoning queue</p>
            </mat-card-content>
        </mat-card>
    </div>
</div>

<!-- Batch Summary Section -->
<div class="container mt-5" *ngIf="airaOutput && airaOutput.queue_details && airaOutput.queue_details.batch_summary">
    <div class="left-side">
        <mat-card>
            <mat-card-header>
                <mat-card-title>Retrieval Batch Summary</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-list>
                    <mat-list-item>
                        <span class="label">Total Batches:</span>
                        <span class="value">{{ airaOutput.queue_details.batch_summary.retrieval_batches.total_batches }}</span>
                    </mat-list-item>
                    <mat-list-item *ngFor="let status of objectKeys(airaOutput.queue_details.batch_summary.retrieval_batches.by_status)">
                        <span class="label">{{ status }}:</span>
                        <span class="value">{{ airaOutput.queue_details.batch_summary.retrieval_batches.by_status[status] }}</span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.queue_details.batch_summary.retrieval_batches.oldest_batch">
                        <span class="label">Oldest Batch:</span>
                        <span class="value">ID {{ airaOutput.queue_details.batch_summary.retrieval_batches.oldest_batch.id }} ({{ airaOutput.queue_details.batch_summary.retrieval_batches.oldest_batch.status }})</span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.queue_details.batch_summary.retrieval_batches.newest_batch">
                        <span class="label">Newest Batch:</span>
                        <span class="value">ID {{ airaOutput.queue_details.batch_summary.retrieval_batches.newest_batch.id }} ({{ airaOutput.queue_details.batch_summary.retrieval_batches.newest_batch.status }})</span>
                    </mat-list-item>
                </mat-list>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="right-side">
        <mat-card>
            <mat-card-header>
                <mat-card-title>Reasoning Batch Summary</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-list>
                    <mat-list-item>
                        <span class="label">Total Batches:</span>
                        <span class="value">{{ airaOutput.queue_details.batch_summary.reasoning_batches.total_batches }}</span>
                    </mat-list-item>
                    <mat-list-item *ngFor="let status of objectKeys(airaOutput.queue_details.batch_summary.reasoning_batches.by_status)">
                        <span class="label">{{ status }}:</span>
                        <span class="value">{{ airaOutput.queue_details.batch_summary.reasoning_batches.by_status[status] }}</span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.queue_details.batch_summary.reasoning_batches.oldest_batch">
                        <span class="label">Oldest Batch:</span>
                        <span class="value">ID {{ airaOutput.queue_details.batch_summary.reasoning_batches.oldest_batch.id }} ({{ airaOutput.queue_details.batch_summary.reasoning_batches.oldest_batch.status }})</span>
                    </mat-list-item>
                    <mat-list-item *ngIf="airaOutput.queue_details.batch_summary.reasoning_batches.newest_batch">
                        <span class="label">Newest Batch:</span>
                        <span class="value">ID {{ airaOutput.queue_details.batch_summary.reasoning_batches.newest_batch.id }} ({{ airaOutput.queue_details.batch_summary.reasoning_batches.newest_batch.status }})</span>
                    </mat-list-item>
                </mat-list>
            </mat-card-content>
        </mat-card>
    </div>


<div class="aira-answers-container" *ngIf="airaOutput && airaOutput.retrieval_model">
    <mat-accordion>
        <mat-expansion-panel *ngFor="let answer of airaOutput.responses; let i = index" style="min-height: 500px;">
            <mat-expansion-panel-header style="min-height: 500px;">
                <mat-panel-title style="min-width: 40%">
                    {{ answer.question }}
                </mat-panel-title>

                <mat-panel-description>
                    <mat-card class="answer-card">
<mat-card-content style="max-height: 400px; overflow-y: auto;">
    <ng-container *ngIf="isString(answer.answer)">
        <p class="answer" [matTooltip]="answer.answer">{{ answer.answer }}</p>
    </ng-container>

    <ng-container *ngIf="isStringArray(answer.answer)">
        <div class="pill-container">
            <span *ngFor="let str of answer.answer" class="string-pill">{{ str }}</span>
        </div>
    </ng-container>

    <ng-container *ngIf="isArrayOfObjects(answer.answer)">
        <div *ngFor="let item of answer.answer">
            <div *ngFor="let key of objectKeys(item)">
                <label class="form-label top-level-label">{{ key }}: </label>
                <ng-container *ngIf="!isArrayOfNumbers(item[key]) && !isStringArray(item[key]) && !isNumber(item[key]); else otherTypes">
                  {{ item[key] }}
                </ng-container>
                <ng-template #otherTypes>
                    <ng-container *ngIf="isStringArray(item[key])">
                        <div class="pill-container">
                            <span *ngFor="let str of item[key]" class="string-pill">{{ str }}</span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="isArrayOfNumbers(item[key])">
                        <div class="histogram-container">
                            <aira-histogram-chart [frequencies]="item[key]"></aira-histogram-chart>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="isNumber(item[key])">
                        {{item[key]}}
                    </ng-container>
                </ng-template>
            </div>
            <hr *ngIf="!lastItem(answer.answer, item)" />
        </div>
    </ng-container>

    <ng-container *ngIf="isArrayOfNumbers(answer.answer)">
        <div class="histogram-container">
            <aira-histogram-chart [frequencies]="answer.answer"></aira-histogram-chart>
        </div>
    </ng-container>

    <ng-container *ngIf="isObject(answer.answer) && !isArrayOfObjects(answer.answer)">
        <div *ngFor="let key of objectKeys(answer.answer)">
            <label class="form-label top-level-label">{{key}}:</label>
            <ng-container *ngIf="isString(answer.answer[key]); else notAnswerKeyString">
                {{ answer.answer[key] }}
            </ng-container>
            <ng-template #notAnswerKeyString>
                <ng-container *ngIf="isStringArray(answer.answer[key]); else notAnswerKeyStringArray">
                        <div class="pill-container">
                        <span *ngFor="let str of answer.answer[key]" class="string-pill">{{ str }}</span>
                    </div>
                </ng-container>
            </ng-template>
                <ng-template #notAnswerKeyStringArray>
                <ng-container *ngIf="isArrayOfNumbers(answer.answer[key]); else notAnswerKeyNumberArray">
                    <div class="histogram-container">
                            <aira-histogram-chart [frequencies]="answer.answer[key]"></aira-histogram-chart>
                        </div>
                </ng-container>
                </ng-template>
                <ng-template #notAnswerKeyNumberArray>
                    <ng-container *ngIf="isArrayOfObjects(answer.answer[key]); else notAnswerKeyObjectArray">
                        <div *ngFor="let item of answer.answer[key]">
                            <div *ngFor="let subKey of objectKeys(item)">
                                <label class="form-label sub">{{ subKey }}: </label>
                                <ng-container *ngIf="isString(item[subKey]); else notSubKeyString">
                                        {{item[subKey]}}
                                </ng-container>
                                    <ng-template #notSubKeyString>
                                        <ng-container *ngIf="isStringArray(item[subKey]); else notSubKeyStringArray">
                                            <div class="pill-container">
                                                <span *ngFor="let str of item[subKey]" class="string-pill">{{str}}</span>
                                            </div>
                                        </ng-container>
                                    </ng-template>
                                        <ng-template #notSubKeyStringArray>
                                            <ng-container *ngIf="isArrayOfNumbers(item[subKey]);else notSubKeyNumberArray">
                                                <div class="histogram-container">
                                                        <aira-histogram-chart [frequencies]="item[subKey]"></aira-histogram-chart>
                                                    </div>
                                            </ng-container>
                                    </ng-template>
                                    <ng-template #notSubKeyNumberArray>
                                            <ng-container *ngIf="isNumber(item[subKey]); else notSubKeyNumber">
                                                    {{item[subKey]}}
                                            </ng-container>
                                           <ng-template #notSubKeyNumber>
                                            {{item[subKey]}}
                                           </ng-template>
                                    </ng-template>
                            </div>
                            <hr/>
                        </div>
                    </ng-container>
                </ng-template>
                <ng-template #notAnswerKeyObjectArray>

                    <ng-container *ngIf="isNumber(answer.answer[key])">
                            {{answer.answer[key]}}
                    </ng-container>
                     <ng-container *ngIf="!isNumber(answer.answer[key]) && !isString(answer.answer[key]) && !isArrayOfNumbers(answer.answer[key]) && !isArrayOfObjects(answer.answer[key]) && !isStringArray(answer.answer[key])">
                           Unknown: {{answer.answer[key] | json}}
                    </ng-container>

                </ng-template>
        </div>
    </ng-container>
</mat-card-content>

                    </mat-card>
                    <div class="confidence-pill" [style.background-color]="getConfidenceColor(answer.confidence)">
                        {{ answer.confidence }}%
                    </div>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="answer-content" style="padding-top: 50px; padding-bottom: 50px">

                <ng-container *ngIf="isArrayOfNumbers(answer.answer)">
                    <aira-histogram-chart [frequencies]="answer.answer"></aira-histogram-chart>
                </ng-container>


                <div *ngIf="answer.commentary">
                    <h4>Commentary:</h4>
                    <p>{{ answer.commentary }}</p>
                </div>

                <div *ngIf="answer.references.length > 0">
                    <h4>References:</h4>
                    <ul>
                        <li *ngFor="let ref of answer.references">
                            <p>
                                <b>Key Info:</b> {{ ref.key_info }}
                            </p>
                            <mat-card *ngIf="ref.quote" class="quote-card">
                                <mat-card-content>
                                    <p class="quote">{{ ref.quote }}</p>
                                </mat-card-content>
                            </mat-card>
                            <p>
                                <b>Source:</b> {{ ref.source }}
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>
